import '../styles/globals.css'
import { CacheProvider } from '@emotion/react'
import { FramerNextPages } from '@graphcommerce/framer-next-pages'
import { GraphQLProvider } from '@graphcommerce/graphql'
import { GlobalHead } from '@graphcommerce/magento-store'
import { CssAndFramerMotionProvider, PageLoadIndicator } from '@graphcommerce/next-ui'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { AppProps } from 'next/app'
import { lightTheme } from '../components/theme'
import { useHotjar } from '../hooks/useHotjar'
import createEmotionCache from '../lib/emotionCache'
import { I18nProvider } from '../lib/i18n/I18nProvider'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'core-js/features/array/at'
import '../builder-registry'
import { CopilotKit } from '@copilotkit/react-core'
import Script from 'next/script'

const emotionCache = createEmotionCache()

export default function ThemedApp(props: AppProps) {
  const { router } = props
  const { locale = 'en' } = router

  useHotjar()

  return (
    <>
      <Script id='oaiq-init' strategy='afterInteractive'>{`
        window.oaiq = window.oaiq || function() {
          (window.oaiq.q = window.oaiq.q || []).push(arguments);
        };
        oaiq("init", { pixelId: "7usY4i1etUsxVUNNTfv5zB" });
      `}</Script>
      <Script src='https://bzrcdn.openai.com/sdk/oaiq.min.js' strategy='afterInteractive' />
      <CopilotKit runtimeUrl='/api/copilotkit' showDevConsole={false}>
      <CssAndFramerMotionProvider>
        <I18nProvider key={locale} locale={locale}>
          <GraphQLProvider {...props}>
            <CacheProvider value={emotionCache}>
              <ThemeProvider theme={lightTheme}>
                <GlobalHead />
                <CssBaseline />
                <PageLoadIndicator />
                <FramerNextPages {...props} />
              </ThemeProvider>
            </CacheProvider>
          </GraphQLProvider>
        </I18nProvider>
      </CssAndFramerMotionProvider>
    </CopilotKit>
    </>
  )
}
